// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InfoBlock_wrapper_1_x1p","icon":"InfoBlock_icon_2FLEc","text":"InfoBlock_text_dFY6s"};